import { RootState } from '@app/store';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';

import {
	pushMessage,
	removeAllMessages,
	removeFirstMessage,
	removeMessage,
	updateMessage,
} from '../model/slice';
import type { TNotification, TUpdatePayload } from '../model/types';

export const useNotifications = () => {
	const dispatch = useAppDispatch();
	const { notifications } = useAppSelector((state: RootState) => state.notifications);

	return {
		notifications,
		pushNotification: (notification: TNotification) => {
			const action = dispatch(pushMessage(notification));
			return action.payload.id; // ← вернули id
		},
		updateNotification: (id: string, changes: TUpdatePayload['changes']) =>
			dispatch(updateMessage({ id, changes })),
		removeNotificationById: (id: string) => dispatch(removeMessage(id)),
		removeAllNotification: () => dispatch(removeAllMessages()),
		removeFirstNotification: () => dispatch(removeFirstMessage()),
	};
};
